import React, { FC, useState } from 'react'

import TextForm from '../../../../components/TextForm'
import { Button } from '@material-ui/core'
import { Table } from '../../../../api/generated'
import TabTile from '../../../../components/TabTile'
import { Highlighted } from '../../../../components/Highlighted'

type DescriptionDatasetTablesProps = {
  search: string
  datasetId?: string
  tableId?: string
  metrics?: Table['metrics']
}

export const DescriptionDatasetMetrics: FC<DescriptionDatasetTablesProps> = ({ datasetId, search, metrics }) => {
  const [expandedMetrics, setExpandeMetrics] = useState('')

  const handleChangeExpandedMetrics = (metricId: string) => {
    const nextValue = expandedMetrics !== metricId ? metricId : ''
    setExpandeMetrics(nextValue)
  }

  return (
    <div>
      {metrics?.map((metricsItem, metricsIndex) => (
        <div
          key={metricsIndex}
          style={{
            background: 'var(--color-selago-grey)',
            margin: '0 -16px',
            padding: '0 16px',
            borderRadius: '10px',
          }}>
          <TabTile
            tab={{
              name: <Highlighted text={metricsItem.metricName} highlight={search} />,
              icon: `${metricsIndex + 1}`,
              description: <Highlighted text={metricsItem.metricDescription} highlight={search} />,
            }}
            expanded={expandedMetrics === metricsItem.metricId}
            onChange={() => handleChangeExpandedMetrics(metricsItem.metricId)}>
            <TextForm
              isFromEdit
              submitButtonLabel="Save changes"
              inputDescription="Metric information"
              inputText={metricsItem.metricName}
              textAreaContent={metricsItem.metricDescription}
              onClick={async (t, textTitle) => {
                console.log('')
              }}
            />
          </TabTile>
        </div>
      ))}

      <Button variant={'contained'} color="primary" style={{ marginTop: 16 }}>
        + Add metrics
      </Button>
    </div>
  )
}
